import type { ComponentProps, ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Placeholder content while data loads; screen readers announce `label` through a status region. */
export function LoadingStatus({
  label,
  className,
  children,
}: {
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div role="status" className={className}>
      <span className="sr-only">{label}</span>
      {children}
    </div>
  );
}

/** A loading block. Forced-colors mode drops its fill, so there it is drawn as a `GrayText` outline. */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      aria-hidden
      className={cn(
        'animate-shimmer rounded-sm bg-border-soft forced-colors:border forced-colors:border-[GrayText]',
        className,
      )}
      {...props}
    />
  );
}
